import React, { useEffect, useState } from "react";
import { getMedias } from "../../../../services/media.service";
import _ from "lodash";
import {
  DeleteOutlined,
  EditOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import EditMedia from "./EditMedia";

import parseMediaUrl from "../../../shared/functions/parseMediaUrl";
import MediaDescriptionRender from "./MediaDescriptionRender";
import {
  deleteMediaByUuid,
  getGlobalMatchdays,
} from "../../../../services/backend/api.service";
import { notification, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "../../../../stores/globalBackendStore";
import {
  DndContext,
  DragOverlay,
  closestCorners,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { ContainerSlide } from "./ContainerSlide";
import { Item } from "./Item";
import EditSlideMedia from "./EditSlideMedia";

const LIMIT = 8;
const defaultAnnouncements = {
  onDragStart(id) {
    console.log(`Picked up draggable item ${id}.`);
  },
  onDragOver(id, overId) {
    if (overId) {
      console.log(
        `Draggable item ${id} was moved over droppable area ${overId}.`,
      );
      return;
    }

    console.log(`Draggable item ${id} is no longer over a droppable area.`);
  },
  onDragEnd(id, overId) {
    if (overId) {
      console.log(
        `Draggable item ${id} was dropped over droppable area ${overId}`,
      );
      return;
    }

    console.log(`Draggable item ${id} was dropped.`);
  },
  onDragCancel(id) {
    console.log(`Dragging was cancelled. Draggable item ${id} was dropped.`);
  },
};

export default (props) => {
  const { t } = useTranslation();
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const [refreshData, setRefreshData] = useState(false);
  const {
    group,
    onSelect,
    initialActiveGroup,
    visibleEdit,
    setVisibleEdit,
    editData,
    setEditData,
    handleRemoveFromSlide,
    slides,
    onOrderChange,
    openEditSlideItem,
    visibleSlideEdit,
    setVisibleSlideEdit,
    editSlideData,
    setEditSlideData,
    feedType,
    onSlideItemChange,
  } = props;
  const [activeId, setActiveId] = useState();
  const [activeItem, setActiveItem] = useState();
  const [images, setImages] = useState([]);
  const [imagesMetadata, setImagesMetadata] = useState({
    hasNextPage: true,
    hasPrevPage: false,
    limit: LIMIT,
    nextPage: 1,
    page: 1,
    pagingCounter: 1,
    prevPage: null,
    totalDocs: null,
    totalPages: null,
  });
  const refreshDataList = ({ group, page, limit }) => {
    getMedias("image", { group, page, limit }).then((data) => {
      const apiItems = _.get(data, "data.docs", []);
      const { docs, ...apiMetadata } = _.get(data, "data", {});
      setImagesMetadata(apiMetadata);
      if (group == "_default") {
        setImages(apiItems);
      } else {
        const filtered = _.filter(apiItems, (item) => {
          if (initialActiveGroup && !group) {
            return (
              item.group === initialActiveGroup || initialActiveGroup === "0"
            );
            // return item.group === group || _.isEmpty(group);
          } else {
            return item.group === group;
          }
        });
        setImages(filtered);
      }

      setRefreshData(false);
    });
  };

  useEffect(() => {
    if (!visibleEdit) {
      refreshDataList({
        group,
        page: 1,
        limit: LIMIT,
      });
      setImagesMetadata({ ...imagesMetadata, page: 1, limit: LIMIT });
    }
  }, [group, visibleEdit]);

  useEffect(() => {
    if (refreshData) {
      refreshDataList({
        group,
        page: imagesMetadata.page,
        limit: imagesMetadata.limit,
      });
    }
  }, [refreshData]);

  const handleSelection = (e, item) => {
    props.onSelect(e, item);
  };

  const handleDelete = async (e, item) => {
    await deleteMediaByUuid({
      uuid: item.uuid,
    }).catch((err) => {
      notification["warning"]({
        message: t("Warning"),
        description: t("Media removing problem: ") + err.message,
        placement: "topRight",
      });
    });

    refreshDataList({ group, page: 1, limit: LIMIT });
    setImagesMetadata({ ...imagesMetadata, page: 1, limit: LIMIT });

    notification["success"]({
      message: t("Success"),
      description: t("Media has been deleted."),
      placement: "topRight",
    });
  };

  const openEdit = (e, item) => {
    setEditData(item);
    setVisibleEdit(true);
  };

  const openEditSlide = (e, item) => {
    setEditSlideData(item);
    setVisibleSlideEdit(true);
  };

  const paginationChange = (page, pageSize) => {
    refreshDataList({ group, page, limit: pageSize });
  };
  const [items, setItems] = useState(slides);

  useEffect(() => {
    setItems(slides);
  }, [slides]);

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    if (feedType) {
      getGlobalMatchdays({ feedType: feedType })
        .then((data) => {
          const apiDataTeams = _.get(data, "data.teams", []);
          setCountries(apiDataTeams);
        })
        .catch((err) => {
          console.error("err", err);
        });
    }
  }, [feedType]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  return (
    <>
      <div className={"media-images-list media-images-list--pagiantion"}>
        <div className="media-images-list-origin-container">
          <EditMedia
            visibleEdit={visibleEdit}
            setVisibleEdit={setVisibleEdit}
            editData={editData}
            setEditData={setEditData}
            setRefreshData={setRefreshData}
            accept={_.get(apiSetup, `mediaLibrary.accept.image`)}
          />
          {visibleSlideEdit && (
            <EditSlideMedia
              visibleEdit={visibleSlideEdit}
              setVisibleEdit={setVisibleSlideEdit}
              editData={editSlideData}
              setEditData={setEditSlideData}
              setRefreshData={setRefreshData}
              accept={_.get(apiSetup, `mediaLibrary.accept.image`)}
              feedType={feedType}
              onSlideItemChange={onSlideItemChange}
              countries={countries}
            />
          )}

          <div className="media-item-list">
            {images.map((item, key) => {
              const updatedAtPrefix = new Date(item.updatedAt).getTime();
              const slideExist = items.find(
                (_item) => _item.uuid === item.uuid,
              );
              const isSelected = !!slideExist;
              return (
                <div
                  key={item.uuid}
                  className={`media-item ${isSelected ? "item-selected" : "item-non-selected"}`}
                >
                  {isSelected ? (
                    <div className={"media-actions"}>
                      <CloseCircleOutlined
                        style={{ color: "red" }}
                        onClick={(e) => {
                          handleRemoveFromSlide(item);
                        }}
                      />
                    </div>
                  ) : (
                    <div className={"media-actions"}>
                      <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={(e) => {
                          handleDelete(e, item);
                        }}
                      />

                      <EditOutlined
                        onClick={(e) => {
                          openEdit(e, item);
                        }}
                      />
                    </div>
                  )}

                  <div
                    className={"media-item-av"}
                    onClick={(e) => handleSelection(e, item)}
                  >
                    <img
                      src={
                        parseMediaUrl(item.url) +
                        `?updated_at=${updatedAtPrefix}`
                      }
                    />
                  </div>
                  <div className={"media-item-data"}>
                    <MediaDescriptionRender item={item} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="pagination-container">
            <Pagination
              onChange={paginationChange}
              current={imagesMetadata.page}
              total={imagesMetadata.totalDocs}
              defaultPageSize={imagesMetadata.limit}
              hideOnSinglePage
            />
          </div>
        </div>
        <div className="media-images-list-order-container">
          <div className="media-item-list">
            <DndContext
              announcements={defaultAnnouncements}
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={handleDragStart}
              onDragOver={handleDragOver}
              onDragEnd={handleDragEnd}
            >
              <ContainerSlide
                items={items}
                handleRemoveFromSlide={handleRemoveFromSlide}
                openEditSlide={openEditSlide}
                feedType={feedType}
                countries={countries}
              />
              <DragOverlay style={{ opacity: 0.9 }}>
                {activeId ? (
                  <div className={"drag-overlay-element"}>
                    <Item item={activeItem} id={activeId} />
                  </div>
                ) : null}
              </DragOverlay>
            </DndContext>
          </div>
        </div>
      </div>
    </>
  );

  function findContainer(id) {
    const typeId = "uuid";
    const foundElement = _.find(items, { [typeId]: id });
    return foundElement ? id : null;
  }

  function handleDragStart(event) {
    const { active } = event;
    const { id } = active;
    const typeId = "uuid";
    const currentItem = _.find(items, { [typeId]: id });
    setActiveId(id);
    setActiveItem(currentItem);
  }

  function handleDragOver({ active, over }) {
    return;
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (!over) return;
    const { id } = active;
    const { id: overId } = over;
    const typeId = "uuid";

    const activeContainer = findContainer(id);
    const overContainer = findContainer(overId);

    if (!activeContainer || !overContainer) {
      return;
    }

    const activeIndex = _.findIndex(items, {
      [typeId]: active.id,
    });
    const overIndex = _.findIndex(items, {
      [typeId]: overId,
    });
    if (activeIndex !== overIndex) {
      //
      const originItems = [...items];
      const newItems = arrayMove(originItems, activeIndex, overIndex);
      setItems(newItems);
      onOrderChange(newItems);
    }

    setActiveId(null);
    setActiveItem(null);
  }
};
